import React from 'react';
import { Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import moment from 'moment';
import { obtenerNombrePersona } from './helpers/bienestarFichaUtils';
import { 
    OTRO_GRUPO, 
    COD_CRISIS, 
    COD_SOL_PASPE, 
    COD_SOL_REM, 
    OTRA_ORIENTACION_BIENESTAR, 
    OTRA_IDENTIDAD_GENERO_BIENESTAR 
} from '../helper';

export function Bienestar({ bienestar }) {
    let {
        tipo_servicio,
        tipo_solicitud,
        estado_actual,
        programa,
        usuario_registro,
        fecha_registro
    } = bienestar || {};

    const ur = usuario_registro || {};

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Solicitante</TableCell>
                    <TableCell align="left">{nombreDePersona(ur)}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Programa</TableCell>
                    <TableCell align="left">{programa?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Tipo Solicitud</TableCell>
                    <TableCell align="left">{tipo_solicitud?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Servicio</TableCell>
                    <TableCell align="left">{tipo_servicio?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Estado Actual</TableCell>
                    <TableCell align="left">{estado_actual?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Fecha Registro</TableCell>
                    <TableCell align="left">{fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : ''}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}

export function DetalleAsistencia({ datos }) {
    let {
        nombre_completo,
        usuario_registro,
        programa_detalle,
        sesion_numero,
        tipo_asesoria_detalle,
        forma_asesoria_detalle,
        funcionario_paspe,
        acepta_proteccion_datos,
        modalidad_detalle,
    } = datos || {};

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Identificación</TableCell>
                    <TableCell align="left">{usuario_registro?.identificacion || ''}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Solicitante</TableCell>
                    <TableCell align="left">{nombre_completo || ''}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{usuario_registro?.celular || ''}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Correo</TableCell>
                    <TableCell align="left">{usuario_registro?.correo || ''}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Correo Personal</TableCell>
                    <TableCell align="left">{usuario_registro?.correo_personal || ''}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Programa</TableCell>
                    <TableCell align="left">{programa_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={7}>
                    <TableCell component="th" scope="row">Numero de Sesion</TableCell>
                    <TableCell align="left">{sesion_numero || ''}</TableCell>
                </TableRow>
                <TableRow key={8}>
                    <TableCell component="th" scope="row">Asesoría Recibida</TableCell>
                    <TableCell align="left">{tipo_asesoria_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={9}>
                    <TableCell component="th" scope="row">Forma Asesoría</TableCell>
                    <TableCell align="left">{forma_asesoria_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={10}>
                    <TableCell component="th" scope="row">Modalidad</TableCell>
                    <TableCell align="left">{modalidad_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={11}>
                    <TableCell component="th" scope="row">Funcionario Paspe</TableCell>
                    <TableCell align="left">{funcionario_paspe || ''}</TableCell>
                </TableRow>
                <TableRow key={12}>
                    <TableCell component="th" scope="row">Protección de Datos</TableCell>
                    <TableCell align="left">{acepta_proteccion_datos ? 'Sí' : acepta_proteccion_datos === false ? 'No' : ''}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}


export function DetalleAgendamiento({ datos }) {
    let {
        detalle_agendamiento
    } = datos || {};
    return (
        <div style={{ border: '1px solid #9e3b3bea', padding: '15px', borderRadius: '8px', backgroundColor: '#ffffffde' }}>
            <Typography variant="body2">Tu asesoría psicológica queda programada de la siguiente manera:</Typography>
            <br />
            <Typography variant="body2"><strong>Psicólog@ Clínico:</strong> {detalle_agendamiento?.profesional_asignado || ''}</Typography>
            <Typography variant="body2"><strong>Fecha y Hora:</strong> {detalle_agendamiento?.fecha_hora_cita || ''}</Typography>
            <Typography variant="body2"><strong>Modalidad:</strong> {detalle_agendamiento?.lugar || ''} </Typography>
            <br />
            <Typography variant="body2" style={{textAlign:'justify'}}>Las sesiones siguientes se realizarán el mismo día y a la misma
                hora a partir de la fecha señalada. Ten presente que el
                incumplimiento a la cita sin previa notificación y justificación
                implica que se ceda el cupo a otro estudiante en lista de espera.
            </Typography>
        </div>
    )
}


export function DetalleSatisfaccion({ datos }) {
    const {
        p1_satisfaccion,
        p2_temas_pertinentes,
        p3_estrategias_utiles,
        p4_comunicacion,
        p5_formacion_integral,
        p6_atencion_servicio,
        p7_bienestar_emocional,
        p8_mejoras,
        p1_comentario_satisfaccion,
        p2_comentario_temas,
        p3_comentario_estrategias,
        p4_comentario_comunicacion,
        p5_comentario_formacion,
        p6_comentario_atencion,
        p7_comentario_bienestar,
        fecha_registro,
        acepta_proteccion_datos
    } = datos || {};

    const esRespuestaNegativa = (valor) => {
        if (!valor) return false;
        return ['malo', 'no', 'regular'].includes(String(valor).toLowerCase());
    };

    const cellStylesQuestion = { width: '70%', verticalAlign: 'top' };
    const cellStylesAnswer = { width: '30%' };

    const preguntas = [
        {
            id: 1,
            texto: '1. ¿Qué tan satisfecho te sentiste con la atención brindada durante tu sesión de asesoría?',
            respuesta: p1_satisfaccion,
            comentario: p1_comentario_satisfaccion
        },
        {
            id: 2,
            texto: '2. ¿Consideras que los temas abordados durante la asesoría fueron pertinentes y acordes a tus necesidades o situación personal?',
            respuesta: p2_temas_pertinentes,
            comentario: p2_comentario_temas
        },
        {
            id: 3,
            texto: '3. ¿Consideras útiles las estrategias o herramientas ofrecidas durante la asesoría para manejar tu situación?',
            respuesta: p3_estrategias_utiles,
            comentario: p3_comentario_estrategias
        },
        {
            id: 4,
            texto: '4. ¿La comunicación y empatía del profesional que te brindó la asesoría fue?',
            respuesta: p4_comunicacion,
            comentario: p4_comentario_comunicacion
        },
        {
            id: 5,
            texto: '5. ¿Consideras que el servicio recibido aporta a tu formación integral?',
            respuesta: p5_formacion_integral,
            comentario: p5_comentario_formacion
        },
        {
            id: 6,
            texto: '6. La atención del servicio que usted recibió fue',
            respuesta: p6_atencion_servicio,
            comentario: p6_comentario_atencion
        },
        {
            id: 7,
            texto: '7. ¿Consideras que el servicio recibido contribuye al mejoramiento de tu bienestar emocional?',
            respuesta: p7_bienestar_emocional,
            comentario: p7_comentario_bienestar
        }
    ];

    return (
        <Table>
            <TableBody>
                {preguntas.map(({ id, texto, respuesta, comentario }) => (
                    <React.Fragment key={id}>
                        <TableRow>
                            <TableCell component="th" scope="row" style={cellStylesQuestion}>
                                {texto}
                            </TableCell>
                            <TableCell align="left" style={cellStylesAnswer}>
                                {respuesta || ''}
                            </TableCell>
                        </TableRow>

                        {esRespuestaNegativa(respuesta) && (
                            <TableRow>
                                <TableCell component="th" scope="row" style={cellStylesQuestion}>
                                    Solicitante Argumenta:
                                </TableCell>
                                <TableCell align="left" style={cellStylesAnswer}>
                                    {comentario || '—'}
                                </TableCell>
                            </TableRow>
                        )}
                    </React.Fragment>
                ))}

                <TableRow>
                    <TableCell component="th" scope="row" style={cellStylesQuestion}>
                        8. Queremos mejorar nuestros servicios para ti. Cuéntanos en qué debemos mejorar
                    </TableCell>
                    <TableCell align="left" style={cellStylesAnswer}>
                        {p8_mejoras || ''}
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" style={cellStylesQuestion}>
                        Fecha Registro
                    </TableCell>
                    <TableCell align="left" style={cellStylesAnswer}>
                        {fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : ''}
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" style={cellStylesQuestion}>
                        Protección de Datos
                    </TableCell>
                    <TableCell align="left" style={cellStylesAnswer}>
                        {acepta_proteccion_datos ? 'Sí' : 'No'}
                    </TableCell>
                </TableRow>

            </TableBody>
        </Table>
    );
}


export function DetalleConsentimiento({ datos }) {
    let {
        usuario_registro,
        nombre_completo_consent,
        contacto_emergencia_1,
        celular_contacto_1,
        parentesco_contacto_1_detalle,
        contacto_emergencia_2,
        celular_contacto_2,
        parentesco_contacto_2_detalle,
        tipo_asesoria_individual_detalle,
        tipo_asesoria_consentimiento_detalle,
        sesion_numero,
        consentimiento_aceptado,
        acepta_proteccion_datos,
        fecha_registro
    } = datos || {};

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Identificación</TableCell>
                    <TableCell align="left">{usuario_registro?.identificacion || ''}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Nombre Completo</TableCell>
                    <TableCell align="left">{nombre_completo_consent || ''}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{usuario_registro?.celular || ''}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Correo Institucional</TableCell>
                    <TableCell align="left">{usuario_registro?.correo || ''}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Correo Personal</TableCell>
                    <TableCell align="left">{usuario_registro?.correo_personal || ''}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Primer Contacto de Emergencia</TableCell>
                    <TableCell align="left">{contacto_emergencia_1 || ''}</TableCell>
                </TableRow>
                <TableRow key={7}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{celular_contacto_1 || ''}</TableCell>
                </TableRow>
                <TableRow key={8}>
                    <TableCell component="th" scope="row">Parentesco</TableCell>
                    <TableCell align="left">{parentesco_contacto_1_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={9}>
                    <TableCell component="th" scope="row">Segundo Contacto de Emergencia</TableCell>
                    <TableCell align="left">{contacto_emergencia_2 || ''}</TableCell>
                </TableRow>
                <TableRow key={10}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{celular_contacto_2|| ''}</TableCell>
                </TableRow>
                <TableRow key={11}>
                    <TableCell component="th" scope="row">Parentesco</TableCell>
                    <TableCell align="left">{parentesco_contacto_2_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={12}>
                    <TableCell component="th" scope="row">Asesoría Individual</TableCell>
                    <TableCell align="left">{tipo_asesoria_individual_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={13}>
                    <TableCell component="th" scope="row">Asesoria</TableCell>
                    <TableCell align="left">{tipo_asesoria_consentimiento_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={14}>
                    <TableCell component="th" scope="row">Sesion Numero</TableCell>
                    <TableCell align="left">{sesion_numero || ''}</TableCell>
                </TableRow>
                <TableRow key={15}>
                    <TableCell component="th" scope="row">Consentimiento</TableCell>
                    <TableCell align="left">{consentimiento_aceptado ? 'Sí' : 'No'}</TableCell>
                </TableRow>
                <TableRow key={16}>
                    <TableCell component="th" scope="row">Protección de Datos</TableCell>
                    <TableCell align="left">{acepta_proteccion_datos ? 'Sí' : 'No'}</TableCell>
                </TableRow>
                <TableRow key={17}>
                    <TableCell component="th" scope="row">Fecha Registro</TableCell>
                    <TableCell align="left">{fecha_registro ? moment(fecha_registro).format('DD/MM/YYYY') : ''}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}

export function DetalleConsentimientoCrisis({ datos }) {
    let {
        usuario_registro,
        nombre_completo_consent,
        contacto_emergencia_1,
        celular_contacto_1,
        parentesco_contacto_1_detalle,
        contacto_emergencia_2,
        celular_contacto_2,
        parentesco_contacto_2_detalle,
        sesion_numero,
        consentimiento_aceptado_crisis,
        acepta_proteccion_datos,
        fecha_registro
    } = datos || {};

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Identificación</TableCell>
                    <TableCell align="left">{usuario_registro?.identificacion || ''}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Nombre Completo</TableCell>
                    <TableCell align="left">{nombre_completo_consent || ''}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{usuario_registro?.celular || ''}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Correo Institucional</TableCell>
                    <TableCell align="left">{usuario_registro?.correo || ''}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Correo Personal</TableCell>
                    <TableCell align="left">{usuario_registro?.correo_personal || ''}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Primer Contacto de Emergencia</TableCell>
                    <TableCell align="left">{contacto_emergencia_1 || ''}</TableCell>
                </TableRow>
                <TableRow key={7}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{celular_contacto_1 || ''}</TableCell>
                </TableRow>
                <TableRow key={8}>
                    <TableCell component="th" scope="row">Parentesco</TableCell>
                    <TableCell align="left">{parentesco_contacto_1_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={9}>
                    <TableCell component="th" scope="row">Segundo Contacto de Emergencia</TableCell>
                    <TableCell align="left">{contacto_emergencia_2 || ''}</TableCell>
                </TableRow>
                <TableRow key={10}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{celular_contacto_2|| ''}</TableCell>
                </TableRow>
                <TableRow key={12}>
                    <TableCell component="th" scope="row">Parentesco</TableCell>
                    <TableCell align="left">{parentesco_contacto_2_detalle?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={13}>
                    <TableCell component="th" scope="row">Sesion Numero</TableCell>
                    <TableCell align="left">{sesion_numero || ''}</TableCell>
                </TableRow>
                <TableRow key={14}>
                    <TableCell component="th" scope="row">Consentimiento</TableCell>
                    <TableCell align="left">{consentimiento_aceptado_crisis ? 'Sí' : 'No'}</TableCell>
                </TableRow>
                <TableRow key={15}>
                    <TableCell component="th" scope="row">Protección de Datos</TableCell>
                    <TableCell align="left">{acepta_proteccion_datos ? 'Sí' : 'No'}</TableCell>
                </TableRow>
                <TableRow key={16}>
                    <TableCell component="th" scope="row">Fecha Registro</TableCell>
                    <TableCell align="left">{fecha_registro ? moment(fecha_registro).format('DD/MM/YYYY') : ''}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}


export function DetalleDisentimiento({ datos }) {
    const {
        usuario_registro,
        acepta_proteccion_datos,
        fecha_registro,
        tipo_solicitud,
        tipo_solicitud_detalle,
        tipo_servicio,
        tipo_servicio_detalle,
        nombre_completo,
        documento,
        adjunto_pdf_url,
        adjunto_pdf,
    } = datos || {};
    const urlPdf = adjunto_pdf_url || adjunto_pdf || '';

    return (
        <Table>
        <TableBody>
            <TableRow>
                <TableCell component="th" scope="row">Nombre del estudiante</TableCell>
                <TableCell align="left">{nombre_completo || ''}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" scope="row">Documento del estudiante</TableCell>
                <TableCell align="left">{documento || ''}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" scope="row">Tipo de solicitud</TableCell>
                <TableCell align="left">
                    {tipo_solicitud_detalle?.nombre || tipo_solicitud?.nombre || tipo_solicitud || ''}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" scope="row">Servicio</TableCell>
                <TableCell align="left">
                    {tipo_servicio_detalle?.nombre || tipo_servicio?.nombre || tipo_servicio || ''}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" scope="row">Protección de Datos</TableCell>
                <TableCell align="left">{acepta_proteccion_datos ? 'Sí' : 'No'}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" scope="row">Fecha Registro</TableCell>
                <TableCell align="left">
                    {fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : ''}
                </TableCell>
            </TableRow>
            {urlPdf ? (
                <TableRow>
                    <TableCell component="th" scope="row">Documento firmado (PDF)</TableCell>
                    <TableCell align="left">
                        <Typography variant="body2">
                            <a href={urlPdf} target="_blank" rel="noopener noreferrer">
                                Descargar PDF
                            </a>
                        </Typography>
                    </TableCell>
                </TableRow>
            ) : null}
        </TableBody>
        </Table>
    );
}


export function DetalleDisentimientoTrasladoEPS({ datos }) {
    const {
        usuario_registro,
        acepta_proteccion_datos,
        fecha_registro,
        nombre_completo,
        documento,
        tipo_solicitud,
        tipo_solicitud_detalle,
        tipo_servicio,
        tipo_servicio_detalle,
        nombre_acudiente,
        numero_identificacion_acudiente,
        comunicacion_decision,
        disposicion_decisiones,
        reconozco_informacion,
        responsable_atencion,
        confirmacion_responsabilidad,
        declaracion_disentimiento,
        importante_aceptacion,
        sesion_numero,
        adjunto_pdf_url,
        adjunto_pdf,
    } = datos || {};
    const urlPdf = adjunto_pdf_url || adjunto_pdf || '';

    const renderBool = (v) => {
        if (v === true || v === 'True' || v === 'SI') return 'Sí';
        if (v === false || v === 'False' || v === 'NO') return 'No';
        return '';
    };

    return (
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell component="th" scope="row">Nombre del estudiante</TableCell>
                    <TableCell align="left">
                        {nombre_completo || `${usuario_registro?.primer_nombre || ''} ${usuario_registro?.primer_apellido || ''} ${usuario_registro?.segundo_apellido || ''}`}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Documento del estudiante</TableCell>
                    <TableCell align="left">{documento || usuario_registro?.identificacion || ''}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Servicio</TableCell>
                    <TableCell align="left">
                        {tipo_servicio_detalle?.nombre || tipo_servicio?.nombre || tipo_servicio || ''}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Tipo de solicitud</TableCell>
                    <TableCell align="left">
                        {tipo_solicitud_detalle?.nombre || tipo_solicitud?.nombre || tipo_solicitud || ''}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Nombre acudiente</TableCell>
                    <TableCell align="left">{nombre_acudiente || ''}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Identificación acudiente</TableCell>
                    <TableCell align="left">{numero_identificacion_acudiente || ''}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Profesional que atendió</TableCell>
                    <TableCell align="left">{responsable_atencion || ''}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Reconoce información de la ruta</TableCell>
                    <TableCell align="left">{renderBool(reconozco_informacion)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">¿Comunica la decisión a las entidades?</TableCell>
                    <TableCell align="left">{renderBool(comunicacion_decision)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">¿Dispuesto(a) a tomar decisiones necesarias?</TableCell>
                    <TableCell align="left">{renderBool(disposicion_decisiones)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Confirmación de responsabilidad del acudiente</TableCell>
                    <TableCell align="left">{renderBool(confirmacion_responsabilidad)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Declaración de disentimiento informado</TableCell>
                    <TableCell align="left">{renderBool(declaracion_disentimiento)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Acepta información importante e implicaciones</TableCell>
                    <TableCell align="left">{renderBool(importante_aceptacion)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Protección de Datos</TableCell>
                    <TableCell align="left">{renderBool(acepta_proteccion_datos)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Formato diligenciado por</TableCell>
                    <TableCell align="left">
                        {`${usuario_registro?.primer_nombre || ''} ${usuario_registro?.primer_apellido || ''} ${usuario_registro?.segundo_apellido || ''}`.trim()}
                        {usuario_registro?.identificacion ? ` — ID: ${usuario_registro.identificacion}` : ''}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row">Fecha Registro</TableCell>
                    <TableCell align="left">
                        {fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : ''}
                    </TableCell>
                </TableRow>
                {urlPdf ? (
                    <TableRow>
                        <TableCell component="th" scope="row">Documento firmado (PDF)</TableCell>
                        <TableCell align="left">
                            <Typography variant="body2">
                                <a href={urlPdf} target="_blank" rel="noopener noreferrer">
                                    Descargar PDF
                                </a>
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : null}
            </TableBody>
        </Table>
    );
}


/** Arma el nombre sin dejar espacios de mas cuando la persona no tiene alguna parte. */
const nombreDePersona = (persona = {}) => [
    persona.primer_nombre,
    persona.segundo_nombre,
    persona.primer_apellido,
    persona.segundo_apellido,
].filter((parte) => parte != null && String(parte).trim() !== '').join(' ');


const RESPUESTA_REMISION = {
    '0': { texto: 'Pendiente', color: '#757575' },
    '1': { texto: 'Aceptada', color: '#078030' },
    '2': { texto: 'Rechazada', color: '#c8102e' },
};

function RespuestaRemision({ confirmacion }) {
    const dato = RESPUESTA_REMISION[String(confirmacion)] || RESPUESTA_REMISION['0'];
    return <span style={{ color: dato.color, fontWeight: 500 }}>{dato.texto}</span>;
}

export function DetalleSolicitud({ bienestar }) {
    let {
        tipo_servicio,
        tipo_solicitud,
        estado_actual,
        programa,
        usuario_registro,
        fecha_registro,
        contacto_emergencia,
        nombre_contacto_emergencia,
        parentesco_detalle,
        relacion,
        nivel_prioridad,
        nombre_remitente,
        remitente_confirmacion,
        motivo,
        lugar_procedencia,
        sisben,
        grupo_priorizado,
        otro_grupo,
        semestre,
        dia_1,
        hora_1,
        dia_2,
        hora_2,
        modalidad,
        sesiones
    } = bienestar || {};

    const ur = usuario_registro || {};
    const profesionalActualObj =
        bienestar?.profesional_asignado
        || bienestar?.detalle_agendamiento?.profesional_asignado
        || null;
    let profesionalAnteriorObj = bienestar?.profesional_anterior || null;
    if (!profesionalAnteriorObj) {
        const estadosConProf = bienestar?.estados_con_profesional || bienestar?.estados || [];
        if (Array.isArray(estadosConProf)) {
            for (const est of estadosConProf) {
                const candidato = est?.profesional_asignado || est?.profesional || null;
                if (!candidato) continue;
                const mismoActual = profesionalActualObj
                    && String(candidato?.id) === String(profesionalActualObj?.id);
                if (!mismoActual) {
                    profesionalAnteriorObj = candidato;
                    break;
                }
            }
        }
    }
    const textoEstadoCivil = typeof ur.estado_civil === 'object' && ur.estado_civil !== null
        ? (ur.estado_civil.nombre || '')
        : (ur.estado_civil || '');
    const textoOrientacionSexual = (() => {
        const os = ur.orientacion_sexual;
        if (!os) return ur.otra_orientacion || '';
        return os.id == OTRA_ORIENTACION_BIENESTAR
            ? `${os.nombre || ''}${ur.otra_orientacion ? ` / ${ur.otra_orientacion}` : ''}`.trim()
            : (os.nombre || '');
    })();
    const textoIdentidadGenero = (() => {
        const ig = ur.identidad_genero;
        if (!ig) return ur.otra_identidad_genero || '';
        return ig.id == OTRA_IDENTIDAD_GENERO_BIENESTAR
            ? `${ig.nombre || ''}${ur.otra_identidad_genero ? ` / ${ur.otra_identidad_genero}` : ''}`.trim()
            : (ig.nombre || '');
    })();

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Identificacion</TableCell>
                    <TableCell align="left">{ur.identificacion || ''}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Solicitante</TableCell>
                    <TableCell align="left">{nombreDePersona(ur)}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Celular</TableCell>
                    <TableCell align="left">{ur.celular || ''}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Correo Institucional</TableCell>
                    <TableCell align="left">{ur.correo || ''}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Correo Personal</TableCell>
                    <TableCell align="left">{ur.correo_personal || ''}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Programa</TableCell>
                    <TableCell align="left">{programa?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={7}>
                    <TableCell component="th" scope="row">Tipo Solicitud</TableCell>
                    <TableCell align="left">{tipo_solicitud?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={8}>
                    <TableCell component="th" scope="row">Servicio</TableCell>
                    <TableCell align="left">{tipo_servicio?.nombre || ''}</TableCell>
                </TableRow>
                {(tipo_solicitud?.codigo == COD_SOL_PASPE && tipo_servicio?.codigo == COD_CRISIS) && (
                    <TableRow key={9}>
                        <TableCell component="th" scope="row">Motivo</TableCell>
                        <TableCell align="left">{motivo}</TableCell>
                    </TableRow>
                )}
                <TableRow key={10}>
                    <TableCell component="th" scope="row">Nombre Contacto Emergencia</TableCell>
                    <TableCell align="left">{nombre_contacto_emergencia || ''}</TableCell>
                </TableRow>
                <TableRow key={'10b'}>
                    {/* En el modelo este campo guarda el telefono, no el nombre. */}
                    <TableCell component="th" scope="row">Celular Contacto Emergencia</TableCell>
                    <TableCell align="left">{contacto_emergencia || ''}</TableCell>
                </TableRow>
                <TableRow key={'10c'}>
                    <TableCell component="th" scope="row">Parentesco</TableCell>
                    <TableCell align="left">{parentesco_detalle?.nombre || ''}</TableCell>
                </TableRow>

                {(tipo_solicitud?.codigo == COD_SOL_REM) &&
                    <>
                        <TableRow key={11}>
                            <TableCell component="th" scope="row">Relación con el Estudiante</TableCell>
                            <TableCell align="left">{relacion?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={12}>
                            <TableCell component="th" scope="row">Nombre Remitente</TableCell>
                            <TableCell align="left">{nombre_remitente}</TableCell>
                        </TableRow>
                        <TableRow key={15}>
                            <TableCell component="th" scope="row">Respuesta del estudiante</TableCell>
                            <TableCell align="left">
                                <RespuestaRemision confirmacion={remitente_confirmacion} />
                            </TableCell>
                        </TableRow>
                        <TableRow key={13}>
                            <TableCell component="th" scope="row">Nivel de prioridad</TableCell>
                            <TableCell align="left">{nivel_prioridad?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={14}>
                            <TableCell component="th" scope="row">Motivo</TableCell>
                            <TableCell align="left">{motivo}</TableCell>
                        </TableRow>
                    </>
                }

                {(tipo_solicitud?.codigo == COD_SOL_PASPE && tipo_servicio?.codigo != COD_CRISIS) &&
                    <>
                        <TableRow key={15}>
                            <TableCell component="th" scope="row">Fecha Nacimiento</TableCell>
                            <TableCell align="left">{ur.fecha_nacimiento ? moment(ur.fecha_nacimiento).format('YYYY-MM-DD') : ''}</TableCell>
                        </TableRow>
                        <TableRow key={16}>
                            <TableCell component="th" scope="row">Edad</TableCell>
                            <TableCell align="left">{ur.fecha_nacimiento ? moment().diff(moment(ur.fecha_nacimiento), 'years') : ''}</TableCell>
                        </TableRow>
                        <TableRow key={17}>
                            <TableCell component="th" scope="row">Sexo biológico</TableCell>
                            <TableCell align="left">{ur.genero?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={18}>
                            <TableCell component="th" scope="row">Orientación Sexual</TableCell>
                            <TableCell align="left">{textoOrientacionSexual}</TableCell>
                        </TableRow> 
                        <TableRow key={19}>
                            <TableCell component="th" scope="row">Identidad de género</TableCell>
                            <TableCell align="left">{textoIdentidadGenero}</TableCell>
                        </TableRow> 
                        <TableRow key={20}>
                            <TableCell component="th" scope="row">Estado civil</TableCell>
                            <TableCell align="left">{textoEstadoCivil}</TableCell>
                        </TableRow>
                        <TableRow key={21}>
                            <TableCell component="th" scope="row">Dirreccion Actual</TableCell>
                            <TableCell align="left">{ur.direccion || ''}</TableCell>
                        </TableRow>
                        <TableRow key={22}>
                            <TableCell component="th" scope="row">Barrio</TableCell>
                            <TableCell align="left">{ur.lugar_residencia || ''}</TableCell>
                        </TableRow>
                        <TableRow key={23}>
                            <TableCell component="th" scope="row">Lugar Procedencia</TableCell>
                            <TableCell align="left">{lugar_procedencia}</TableCell>
                        </TableRow>
                        <TableRow key={24}>
                            <TableCell component="th" scope="row">Departamento</TableCell>
                            <TableCell align="left">{ur.departamento?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={25}>
                            <TableCell component="th" scope="row">Municipio</TableCell>
                            <TableCell align="left">{ur.ciudad?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={26}>
                            <TableCell component="th" scope="row">EPS</TableCell>
                            <TableCell align="left">{ur.eps?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={27}>
                            <TableCell component="th" scope="row">Sisbén</TableCell>
                            <TableCell align="left">{sisben == '1' ? 'SI': 'NO'}</TableCell>
                        </TableRow>
                        <TableRow key={28}>
                            <TableCell component="th" scope="row">Grupo Priorizado</TableCell>
                            <TableCell align="left">{grupo_priorizado && grupo_priorizado.id == OTRO_GRUPO ? `${grupo_priorizado.nombre || ''} / ${otro_grupo || ''}`.trim() : (grupo_priorizado?.nombre || '')}</TableCell>
                        </TableRow>
                        <TableRow key={29}>
                            <TableCell component="th" scope="row">Semestre</TableCell>
                            <TableCell align="left">{semestre}</TableCell>
                        </TableRow>
                        <TableRow key={30}>
                            <TableCell component="th" scope="row">Horario 1</TableCell>
                            <TableCell align="left">{`${dia_1} ${hora_1}`}</TableCell>
                        </TableRow>
                        <TableRow key={31}>
                            <TableCell component="th" scope="row">Horario 2</TableCell>
                            <TableCell align="left">{`${dia_2} ${hora_2}`}</TableCell>
                        </TableRow>
                        <TableRow key={32}>
                            <TableCell component="th" scope="row">Modalidad</TableCell>
                            <TableCell align="left">{modalidad?.nombre || ''}</TableCell>
                        </TableRow>
                        <TableRow key={33}>
                            <TableCell component="th" scope="row">Sesiones</TableCell>
                            <TableCell align="left">{sesiones}</TableCell>
                        </TableRow>
                        <TableRow key={34}>
                            <TableCell component="th" scope="row">Motivo</TableCell>
                            <TableCell align="left">{motivo}</TableCell>
                        </TableRow>
                    </>
                }
                <TableRow key={35}>
                    <TableCell component="th" scope="row">Estado Actual</TableCell>
                    <TableCell align="left">{estado_actual?.nombre || ''}</TableCell>
                </TableRow>
                <TableRow key={36}>
                    <TableCell component="th" scope="row">Fecha Registro</TableCell>
                    <TableCell align="left">{fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : ''}</TableCell>
                </TableRow>
                {profesionalActualObj ? (
                    <TableRow key={37}>
                        <TableCell component="th" scope="row">Profesional Actual</TableCell>
                        <TableCell align="left">{obtenerNombrePersona(profesionalActualObj) || ''}</TableCell>
                    </TableRow>
                ) : null}
                {profesionalAnteriorObj ? (
                    <TableRow key={38}>
                        <TableCell component="th" scope="row">Profesional Anterior</TableCell>
                        <TableCell align="left">{obtenerNombrePersona(profesionalAnteriorObj) || ''}</TableCell>
                    </TableRow>
                ) : null}
            </TableBody>
        </Table>
    )
}
